<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search_box">
                <el-form :model="searchForm" size="small" inline>
                    <el-form-item label="管理级别：">
                        <div class="el-input__inner search_dialog_input"
                                @click="showDep = true">
                            <span v-if="searchForm.jobs" class="show_text">
                                <span>{{ searchForm.jobs }}</span>
                                <i @click.stop="clear_jobs"
                                   class="del_icon el-icon-close"></i>
                            </span>
                            <span class="holder_text"
                                  v-if="!searchForm.jobs">
                                请选择岗位
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item label="省：">
                        <el-select v-model="searchForm.province"
                                   @change="getTableData()"
                                   clearable
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in province_list"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="截止日期：">
                        <el-date-picker
                                v-model="searchForm.end_date"
                                type="date"
                                :picker-options="pickeroptions"
                                @change="getTableData()"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="统计维度：">
                        <el-select v-model="searchForm.dimensionality"
                                   @change="getTableData()"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in dimensionality_list"
                                    :key="item"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getTableData()">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <span :class="avtive_view === 'echart'?'active_icon_btn':''"
                      @click="changeView('echart')"
                      class="icon_btn iconfont icon-tubiao-bingtu"></span>
                <span :class="avtive_view === 'table'?'active_icon_btn':''"
                      @click="changeView('table')"
                      class="icon_btn iconfont icon-biaoge"></span>
            </div>
        </div>

        <div class="table" v-if="avtive_view === 'echart'">
            <div v-for="(item, index) in tableData" :key="index" class="table_td">
                <div class="td_title">{{item.item}}</div>
                <div class="td_main">
                    <div class="item">
                        <echarts-view :echart_data="item"
                                      :one="index"
                                      :width="350"
                                      :two="1"></echarts-view>
                    </div>
                    <div class="item">
                        <echarts-view :echart_data="item"
                                      :one="index"
                                      :width="350"
                                      :two="2"></echarts-view>
                    </div>
                    <div class="item">
                        <echarts-view :echart_data="item"
                                      :one="index"
                                      :width="400"
                                      :two="3"></echarts-view>
                    </div>
                    <div class="item last_item">
                        <div class="top_dot">
                        <span class="num">DOT：
                            <span style="color: #00599C">{{item.dot}}</span>
                        </span>
                            <span> 支</span>
                        </div>
                        <div class="progress_box">
                            <el-progress :text-inside="true"
                                         :stroke-width="26"
                                         :percentage="calcPro(item.dot)"></el-progress>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="table" v-if="avtive_view === 'table'">
            <el-table :data="tableData"
                      width="100%"
                      show-summary
                      :summary-method="showSummary"
                      stripe>
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :min-width="item.min_width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 :sortable="item.sortable"
                                 v-if="showColumn(item.show)"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
            </el-table>
        </div>

        <el-dialog
                title="岗位选择"
                :visible.sync="showDep"
                width="30%"
                :modal-append-to-body="false"
        >
            <div style="height: 500px; overflow: hidden; overflow-y: auto">
                <el-tree
                        :data="treeData"
                        node-key="department_id"
                        :props="treeOptions"
                        @node-click="clickNode"
                        class="office_tree"
                        highlight-current
                        default-expand-all
                        :expand-on-click-node="false"
                >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span @click.stop="" class="caozuo_btn"> </span>
                </span>
                </el-tree>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone, formatTime} from "@/global/utils";
    import {downGet} from "@/api";
    import echartsView from "./echartsView"

    export default {
        name: "tableView",
        components: {
            echartsView
        },
        data() {
            const addProgress = (row, column, cellValue, index) => {
                let text = cellValue ? cellValue : 0;
                return text + '%'
            };
            return {
                currentPage: 1,
                pageSize: 50,
                total: 0,
                avtive_view: 'echart',

                showDep: false,
                treeData: [],
                treeOptions: {
                    label: "name",
                    children: "children",
                },

                searchForm: {
                    end_date: '',
                    dimensionality: 'PROVINCE',
                    province: '',
                    jobs: '',
                    department_id: '',
                },
                options: [],
                province_list: [],
                dimensionality_list: [
                    {name: '省', value: 'PROVINCE'},
                    {name: 'DSM', value: 'DSM'},
                    {name: 'RSM', value: 'RSM'},
                    {name: 'SD', value: 'SD'},
                ],
                pickeroptions: {
                    disabledDate: time => {
                        return time.getTime() > Date.now() // 可选历史、当前，不可选未来
                    },
                },

                tableData: [],
                columnData: [
                    {min_width: 140, label: 'BU', prop: 'bu', show: 'bu'},
                    {min_width: 140, label: '区域', prop: 'region', show: 'region'},
                    {min_width: 140, label: '大区', prop: 'district', show: 'district'},
                    {min_width: 140, label: 'DSM', prop: 'dsm_name', show: 'dsm_name'},
                    {min_width: 140, label: '省', prop: 'province', show: 'province'},
                    {min_width: 100, sortable: true, label: '已注册', prop: 'reg_count'},
                    {min_width: 100, sortable: true, label: '待注册', prop: 'not_reg_count'},
                    {min_width: 100, sortable: true, label: '注册率', prop: 'reg_ratio', formatter: addProgress},
                    {min_width: 100, sortable: true, label: '已填报', prop: 'fill_count'},
                    {min_width: 100, sortable: true, label: '待填报', prop: 'not_fill_count'},
                    {min_width: 110, sortable: true, label: '填报P数', prop: 'total_fill_count'},
                    {min_width: 100, sortable: true, label: '填报率', prop: 'fill_ratio', formatter: addProgress},
                    {min_width: 130, sortable: true, label: '待提醒复购', prop: 'not_remind_count'},
                    {min_width: 130, sortable: true, label: '待提醒比例', prop: 'remind_ratio', formatter: addProgress},
                    {min_width: 100, sortable: true, label: '关注数', prop: 'subscribe_count'},
                    {min_width: 100, sortable: true, label: 'DOT', prop: 'dot'},
                ]
            }
        },
        mounted() {
            let time = (new Date()).getTime() - 3600*1000*24;
            this.searchForm.end_date = formatTime(new Date(time)).time1;
            this.getProvince();
            this.getTree();
            this.getTableData()
        },
        methods: {
            showColumn(val) {
                if (!val) return true;
                let show = false;
                if (val === 'region') {
                    // 区域
                    show = this.searchForm.dimensionality === 'DSM' ||
                        this.searchForm.dimensionality === 'RSM' ||
                        this.searchForm.dimensionality === 'SD'
                } else if (val === 'district') {
                    // 大区
                    show = this.searchForm.dimensionality === 'DSM' ||
                        this.searchForm.dimensionality === 'RSM'
                } else if (val === 'bu') {
                    show = this.searchForm.dimensionality === 'DSM' ||
                        this.searchForm.dimensionality === 'RSM' ||
                        this.searchForm.dimensionality === 'SD'
                } else if (val === 'province') {
                    show = this.searchForm.dimensionality === 'PROVINCE'
                } else if (val === 'dsm_name') {
                    show = this.searchForm.dimensionality === 'DSM'
                }
                return show
            },
            showSummary(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = '';
                    }
                    if (column.label=='注册率'||
                        column.label=='填报率'||
                        column.label=='待提醒比例'||
                        column.label=='DOT') {
                        sums[index] = '';
                    }
                });
                return sums;
            },
            changeView(val) {
                this.avtive_view = val;
            },
            calcPro(dot) {
            //    计算DOT进度条百分比 以8为满
                let num = 0;
                if (dot) {
                    num = Number(dot) * 100 / 8;
                }
                return Number(num.toFixed(0))
            },

            getTableData() {
                let params = {
                    stat_date: this.searchForm.end_date,
                    province: this.searchForm.province,
                    department_id: this.searchForm.department_id,
                    group_by: this.searchForm.dimensionality
                };
                this.httpGet('/stat_rep/stat', params).then(res => {
                    this.tableData = res.data;
                    this.$forceUpdate();
                })
            },

            getProvince() {
                this.httpGet('/stat_rep/province/list').then(res => {
                    this.province_list = res.data
                })
            },
            getTree() {
                this.httpGet("/department").then((res) => {
                    this.treeData = res.data;
                    this.treeData.map(v1 => {
                        if (v1.children && v1.children.length > 0) {
                            // level 1
                            v1.children.map(v2 => {
                                if (v2.children && v2.children.length > 0) {
                                    // level 2
                                    v2.children.map(v3 => {
                                        if (v3.children && v3.children.length > 0) {
                                            // level 3
                                            v3.children.map(v4 => {
                                                // level 4
                                                v4.children = []
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })

                });
            },
            clickNode(val) {
                this.searchForm.jobs = val.name;
                this.searchForm.department_id = val.department_id;
                this.showDep = false;
                this.getTableData();
                // console.log("clickNode----", val);
            },
            clear_jobs() {
                this.searchForm.jobs = '';
                this.searchForm.department_id = '';
                this.getTableData();
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        .header {
            .search_dialog_input {
                background: #fff;
                border: 1px solid #dcdfe6;
                cursor: pointer;
                height: 33px;
                line-height: 33px;
                width: 220px;
                box-sizing: border-box;
                .show_text {
                    display: flex;
                    justify-content: space-between;
                    .del_icon {
                        display: none;
                        line-height: 33px;
                        padding-left: 5px;
                    }
                    &:hover {
                        .del_icon {
                            display: inline;
                        }
                    }
                }
                .holder_text {
                    color: #dcdfe6;
                }
            }

            .search_box {
                flex: 1;
            }
            .btn_box {
                flex: 0 0 100px;
                display: flex;
                justify-content: space-around;
                .icon_btn {
                    padding: 0 5px;
                    font-size: 1.5rem;
                    cursor: pointer;
                }
                .active_icon_btn {
                    color: #409EFF;
                }
            }
        }
        .table {
            overflow: hidden;
            overflow-y: auto;
            .table_td {
                border-bottom: 1px solid #EBEEF5;
                box-sizing: border-box;
                .td_title {
                    font-size: 1.4rem;
                    font-weight: 600;
                    padding: 10px 20px 0;
                }
                .td_main {
                    display: flex;
                    overflow-x: auto;
                    .item {
                        flex: 1;
                        box-sizing: border-box;
                        padding: 5px;
                    }
                    .last_item {
                        flex: 0 0 200px;
                        align-self: center;
                        /*border-left: 1px solid #DCDFE6;*/
                        box-sizing: border-box;
                        .top_dot {
                            font-size: 1rem;
                            border-bottom: 1px solid #DCDFE6;
                            padding: 10px 0;
                            box-sizing: border-box;
                            .num {
                                font-size: 1.4rem;
                                font-weight: 600;
                            }
                        }
                        .progress_box {
                            margin: 20px 0;
                            box-sizing: border-box;
                        }
                    }
                }

            }
        }
    }
</style>